import { type Transition, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

const tokens = {
    zindex: {
        base: 20,
    },
    container: {
        columns: 5,
        rows: 5,
    },
    triangle: {
        // All of these are relative `%` values.
        offset: 32,
        widths: [50, 54, 58, 62, 66, 70],
        motion: {
            duration: {
                ms: 1000,
                sec: 1,
            },
        },
    },
};
export enum FloorGameCardVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const floorGameCardTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.slowest,
};

export const floorGameCardVariants: Variants = {
    [FloorGameCardVariant.Hidden]: {
        opacity: 0,
        transition: {
            ...floorGameCardTransition,
            delay: tokens.triangle.motion.duration.sec,
        },
    },
    [FloorGameCardVariant.Show]: {
        opacity: 1,
        transition: floorGameCardTransition,
    },
};
